import { UUID } from 'crypto';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCreateOrUpdateTicketMutation, useGetTicketListeMutation } from '../../api/TicketAPI';
import { RootState } from '../../Store';
import { ITicket } from '../../types/Types';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import TicketCard from './component/TicketCard';
import styles from './ticketMain.module.scss';

/**
 * @author noone
 */
export default function TicketMain() {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const auth = useSelector((state: RootState) => state.authSlice.auth);

    const [getTickets] = useGetTicketListeMutation();
    const [updateTicketAPI] = useCreateOrUpdateTicketMutation();
    const [statusZumAnzeigen, setStatusZumAnzeigen] = useState<string>("OFFEN");

    const [liste, setListe] = useState<ITicket[]>([]);
    const [gefilterteListe, setGefilterteListe] = useState<ITicket[]>([]);
    const [detailTicket, setDetailTicket] = useState<ITicket | null>(null);
    const [kurzbeschreibung, setKurzbeschreibung] = useState<string>("");
    const [langbeschreibung, setLangbeschreibung] = useState<string>("");

    function refresh() {
        getTickets().unwrap()
            .then(data => setListe(data))
            .catch((error) => console.log("ERROR: " + error));
    }

    function handleTicketStatusChanged() {
        setGefilterteListe([]);
        refresh();
        setDetailTicket(null);
    }

    const filterListe = () => {
        const gefilterteTickets = liste.filter(ticket => ticket.status === statusZumAnzeigen);
        setGefilterteListe(gefilterteTickets);
    }

    useEffect(() => {
        filterListe();
    }, [liste]);

    useEffect(() => {
        setDetailTicket(null);
        filterListe();
    }, [statusZumAnzeigen]);

    useEffect(() => {
        refresh();
    }, []);

    const submit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        updateTicketAPI({
            uid: "",
            kurzbeschreibung: kurzbeschreibung,
            langbeschreibung: langbeschreibung,
            reporter: (auth.user) ? auth.user?.email : "unbekannt",
            status: "OFFEN",
        })
            .then(() => { refresh(); })
            .then(() => {
                setKurzbeschreibung("");
                setLangbeschreibung("");
            })
            .catch((error: unknown) => alert("" + error));
    }

    const getAnzahlTickets = (status: string) => {
        return liste.filter(ticket => ticket.status === status).length
    }

    return (
        <div className="container">

            <LandingpageHeader />

            <button
                onClick={() => {
                    navigate({
                        pathname: "/",
                        search: ""
                    });
                }}

                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-primary'
            >
                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
            </button>

            <h3>Tickets</h3>

            <div style={{ marginTop: "30px" }}>
                <h4>Neues Ticket erstellen</h4>
                <form onSubmit={submit} className='form-horizontal'>
                    <div className="form-group">
                        <label htmlFor="kurzbeschreibung">Titel:</label>
                        <input type="text" className="form-control" id="kurzbeschreibung" value={kurzbeschreibung} onChange={(e) => setKurzbeschreibung(e.target.value)} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="langbeschreibung">Beschreibung:</label>
                        <textarea className="form-control"
                            id="langbeschreibung"
                            value={langbeschreibung}
                            rows={8}
                            onChange={(e) => setLangbeschreibung(e.target.value)} >
                        </textarea>
                    </div>
                    <input type='submit' value='Speichern' className="btn btn-primary" />
                </form>
            </div>

            <div className={styles.statusCardContainer} >

                <div className={styles.statusCard + " card"} style={{ backgroundColor: "orange", color: "white" }} onClick={() => setStatusZumAnzeigen("OFFEN")}>
                    <span className={styles.cardSpan}>
                        Offen ({getAnzahlTickets("OFFEN")})
                    </span>
                </div>

                <div className={styles.statusCard + " card"} style={{ backgroundColor: "blue", color: "white" }} onClick={() => setStatusZumAnzeigen("IN_BEARBEITUNG")}>
                    <span className={styles.cardSpan}>
                        In Bearbeitung ({getAnzahlTickets("IN_BEARBEITUNG")})
                    </span>
                </div>

                <div className={styles.statusCard + " card"} style={{ backgroundColor: "#e2e6ea", color: "black" }} onClick={() => setStatusZumAnzeigen("IN_ABNAHME")}>
                    <span className={styles.cardSpan}>
                        In Abnahme ({getAnzahlTickets("IN_ABNAHME")})
                    </span>
                </div>

                <div className={styles.statusCard + " card"} style={{ backgroundColor: "green", color: "white" }} onClick={() => setStatusZumAnzeigen("FERTIG")}>
                    <span className={styles.cardSpan}>
                        Fertig ({getAnzahlTickets("FERTIG")})
                    </span>
                </div>

            </div>

            <div className={styles.ticketCardContainer} >

                <div>
                    Anzahl : {gefilterteListe?.length}
                    <ul
                        style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                        {gefilterteListe?.map(item => (
                            <li key={item.uid}>
                                <div onClick={() => setDetailTicket(item)}
                                    style={{ cursor: "pointer", padding: "10px", border: "1px solid #ccc", marginBottom: "10px", borderRadius: "5px", backgroundColor: detailTicket?.uid === item.uid ? "#f0f0f0" : "#fff" }}
                                >
                                    TICKET-{item.id} : {item.kurzbeschreibung}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    {detailTicket !== null && <TicketCard
                        ticket={detailTicket}
                        refresh={handleTicketStatusChanged} />}
                </div>
            </div>
            <Footer />
        </div >
    );

}

export type ISache = {
    uid?: UUID,
    name: string,
    createDate: string,
}